import React from "react";
import { IconSharedWithMe } from "icons";
import { SleekToggle } from "components/Sleek/SleekToggle";

/**
 * "Shared with me" toggle of a page's toolbar (Moodboards, Design Canvas, Photoshoot Studio, Tech Packs, Bulk Process),
 * in the Trends pages' finish (2026-10-26) — one component where five pages each drew their own. Its words are the
 * page's (each says it in its own namespace).
 */
const SharedWithMeButton = ({ active, onClick, label, testId }: { active: boolean; onClick: () => void; label: string; testId?: string }) => (
  <SleekToggle active={active} onClick={onClick} icon={<IconSharedWithMe className="h-4 w-4 flex-shrink-0" />} label={label} {...(testId && { "data-testid": testId })} />
);

export default SharedWithMeButton;
